<template>
    <div>
        <fieldset :class="fieldsetClasses">
            <div v-for="(option, index) in options" :key="index" :class="labelWrapperClasses">
                <input type="radio" :id="option.value" :name="name" v-model="selectedOption" :value="option.value" :required="required">
                <label :for="option.value" :class="labelClasses">{{ option.label }}</label>
            </div>
        </fieldset>
        <div v-for="(option, index) in options" :key="index" :class="slotWrapperClasses">
            <slot :name="option.value" v-if="selectedOption == option.value"></slot>
        </div>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue';

interface RadioOption {
    value: string;
    label: string;
}
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        options: {
            type: Array as PropType<RadioOption[]>,
            required: true
        },
        fieldsetClasses: {
            type: String,
            required: false
        },
        labelClasses: {
            type: String,
            required: false
        },
        labelWrapperClasses: {
            type: String,
            required: false
        },
        slotWrapperClasses: {
            type: String,
            required: false
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            selectedOption: null
        };
    }
};

</script>
